// "use client"

// import { useState } from "react"
// import { startbg } from "../Assets"

// const CheckWhitelist = () => {
//   const [walletAddress, setWalletAddress] = useState("")
//   const [loading, setLoading] = useState(false)
//   const [result, setResult] = useState(null)
//   const [error, setError] = useState("")

//   // Validate EVM wallet address format
//   const isValidAddress = (address) => {
//     return /^0x[a-fA-F0-9]{40}$/.test(address)
//   }

//   const handleCheck = async () => {
//     setError("")
//     setResult(null)

//     // Validate address format
//     if (!walletAddress.trim()) {
//       setError("Please enter a wallet address")
//       return
//     }

//     if (!isValidAddress(walletAddress.trim())) {
//       setError("Invalid EVM wallet address format")
//       return
//     }

//     setLoading(true)

//     try {
//       // TODO: Replace with actual Neon database query
//       // Example API call structure:
//       // const response = await fetch('/api/check-whitelist', {
//       //   method: 'POST',
//       //   headers: { 'Content-Type': 'application/json' },
//       //   body: JSON.stringify({ address: walletAddress.trim() })
//       // });
//       // const data = await response.json();

//       // Simulated response for now
//       await new Promise((resolve) => setTimeout(resolve, 1000))

//       // Mock result - replace with actual database check
//       const isWhitelisted = Math.random() > 0.5 // Random for demo
//       setResult({
//         address: walletAddress.trim(),
//         whitelisted: isWhitelisted,
//       })
//     } catch (err) {
//       setError("Failed to check whitelist status. Please try again.")
//       console.error("[v0] Error checking whitelist:", err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       handleCheck()
//     }
//   }

//   return (
//     <div className="w-full min-h-screen flex flex-col items-center justify-center px-4 py-20 relative overflow-hidden">
//       {/* Background images */}
//       <img
//         src={startbg || "/placeholder.svg"}
//         alt="Background Top Right"
//         className="absolute top-0 right-0 w-[300px] sm:w-[500px] lg:w-[600px] opacity-30 z-0"
//       />
//       <img
//         src={startbg || "/placeholder.svg"}
//         alt="Background Bottom Left"
//         className="absolute bottom-0 left-0 w-[300px] sm:w-[500px] lg:w-[600px] opacity-30 z-0"
//       />

//       <div className="max-w-2xl w-full space-y-8 relative z-10">
//         {/* Header */}
//         <div className="text-center space-y-4">
//           <p className="text-white text-6xl sm:text-[100px] font-bold -mb-16 sm:-mb-24 text-outline">Check</p>
//           <h1 className="text-4xl sm:text-6xl text-white font-semibold">Check Whitelist Status</h1>
//           <p className="text-[#D8D8D8] text-lg sm:text-xl">Enter your EVM wallet address to verify whitelist status</p>
//         </div>

//         {/* Input Section */}
//         <div className="bg-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-6 sm:p-8 space-y-6">
//           <div className="space-y-2">
//             <label htmlFor="wallet-address" className="text-white text-sm font-medium block">
//               Wallet Address
//             </label>
//             <input
//               id="wallet-address"
//               type="text"
//               value={walletAddress}
//               onChange={(e) => setWalletAddress(e.target.value)}
//               onKeyPress={handleKeyPress}
//               placeholder="0x..."
//               className="w-full px-4 py-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-[#E300F3] focus:ring-2 focus:ring-[#E300F3]/50 transition-all"
//               disabled={loading}
//             />
//           </div>

//           {error && (
//             <div className="bg-red-500/10 border border-red-500/50 rounded-lg p-4">
//               <p className="text-red-400 text-sm">{error}</p>
//             </div>
//           )}

//           <button
//             onClick={handleCheck}
//             disabled={loading}
//             className="w-full px-8 py-3 bg-gradient-to-r from-[#E300F3] to-[#620268] text-white font-semibold rounded-full transform hover:scale-105 transition-transform duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
//           >
//             {loading ? "Checking..." : "Check Whitelist"}
//           </button>
//         </div>

//         {/* Result Section */}
//         {result && (
//           <div
//             className={`bg-white/5 backdrop-blur-sm border ${
//               result.whitelisted ? "border-green-500/50" : "border-red-500/50"
//             } rounded-2xl p-6 sm:p-8 space-y-4 animate-in fade-in duration-500`}
//           >
//             <div className="flex items-center justify-between">
//               <h3 className="text-white text-xl font-semibold">Result</h3>
//               <span
//                 className={`px-4 py-1 rounded-full text-sm font-medium ${
//                   result.whitelisted ? "bg-green-500/20 text-green-400" : "bg-red-500/20 text-red-400"
//                 }`}
//               >
//                 {result.whitelisted ? "Whitelisted" : "Not Whitelisted"}
//               </span>
//             </div>
//             <div className="space-y-2">
//               <p className="text-gray-400 text-sm">Address</p>
//               <p className="text-white font-mono text-sm break-all">{result.address}</p>
//             </div>
//             {result.whitelisted ? (
//               <p className="text-green-400 text-sm">This wallet address is whitelisted and eligible for access.</p>
//             ) : (
//               <p className="text-red-400 text-sm">This wallet address is not currently whitelisted.</p>
//             )}
//           </div>
//         )}

//         {/* Info Section */}
//         <div className="bg-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-6 space-y-3">
//           <h4 className="text-white font-semibold">About Whitelist</h4>
//           <p className="text-gray-400 text-sm leading-relaxed">
//             The whitelist verification system checks if your wallet address is registered in our database. Whitelisted
//             addresses have access to exclusive features and benefits within the Monadscore ecosystem.
//           </p>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default CheckWhitelist













"use client"

import { useState } from "react"
import { startbg } from "../Assets"
import axios from "axios"

const CheckWhitelist = () => {
  const [walletAddress, setWalletAddress] = useState("")
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState(null)
  const [error, setError] = useState("")

  const apiUrl = process.env.API_URL

  // Validate EVM wallet address format
  const isValidAddress = (address) => {
    return /^0x[a-fA-F0-9]{40}$/.test(address)
  }

  const handleCheck = async () => {
    setError("")
    setResult(null)

    // Validate address format
    if (!walletAddress.trim()) {
      setError("Please enter a wallet address")
      return
    }

    if (!isValidAddress(walletAddress.trim())) {
      setError("Invalid EVM wallet address format")
      return
    }

    setLoading(true)

    try {
      // let response = await axios.post(`${apiUrl}/api/user/claim-task`, { wallet: address, taskId: taskId }, {
      //   headers: { Authorization: `Bearer ${token}` }
      // });
      // const response = await fetch(`${apiUrl}/api/check-whitelist`, {
      // const response = await fetch(`http://localhost:9000/api/check-whitelist`, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({ walletAddress: walletAddress.trim() }),
      // })

      const response = await axios.post(
        "https://mscore-production.up.railway.app/api/check-whitelist",
        { walletAddress: walletAddress.trim() },
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000, // optional: 10s timeout
        }
      );

      console.log("response", response)

      if (!response.data.success) {
        // const errorData = await response.json()
        throw new Error( "Failed to check whitelist")
      }

      

      setResult({
        address: response.data.data.wallet,
        whitelisted: response.data.whitelisted,
    
      })
    } catch (err) {
      setError(err.message || "Failed to check whitelist status. Please try again.")
      console.error("[v0] Error checking whitelist:", err)
    } finally {
      setLoading(false)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleCheck()
    }
  }


  console.log("result", result)
  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center px-4 py-20 relative overflow-hidden">
      {/* Background images */}
      <img
        src={startbg || "/placeholder.svg"}
        alt="Background Top Right"
        className="absolute top-0 right-0 w-[300px] sm:w-[500px] lg:w-[600px] opacity-30 z-0"
      />
      <img
        src={startbg || "/placeholder.svg"}
        alt="Background Bottom Left"
        className="absolute bottom-0 left-0 w-[300px] sm:w-[500px] lg:w-[600px] opacity-30 z-0"
      />

      <div className="max-w-2xl w-full space-y-8 relative z-10">
        {/* Header */}
        <div className="text-center space-y-4">
          <p className="text-white text-6xl sm:text-[100px] font-bold -mb-16 sm:-mb-24 text-outline">Check</p>
          <h1 className="text-4xl sm:text-6xl text-white font-semibold">Check Whitelist Status</h1>
          <p className="text-[#D8D8D8] text-lg sm:text-xl">Enter your EVM wallet address to verify whitelist status</p>
        </div>

        {/* Input Section */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-6 sm:p-8 space-y-6">
          <div className="space-y-2">
            <label htmlFor="wallet-address" className="text-white text-sm font-medium block">
              Wallet Address
            </label>
            <input
              id="wallet-address"
              type="text"
              value={walletAddress}
              onChange={(e) => setWalletAddress(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="0x..."
              className="w-full px-4 py-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-[#E300F3] focus:ring-2 focus:ring-[#E300F3]/50 transition-all"
              disabled={loading}
            />
          </div>

          {error && (
            <div className="bg-red-500/10 border border-red-500/50 rounded-lg p-4">
              <p className="text-red-400 text-sm">{error}</p>
            </div>
          )}

          <button
            onClick={handleCheck}
            disabled={loading}
            className="w-full px-8 py-3 bg-gradient-to-r from-[#E300F3] to-[#620268] text-white font-semibold rounded-full transform hover:scale-105 transition-transform duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
          >
            {loading ? "Checking..." : "Check Whitelist"}
          </button>
        </div>

        {/* Result Section */}
        {result && (
          <div
            className={`bg-white/5 backdrop-blur-sm border ${
              result.whitelisted ? "border-green-500/50" : "border-red-500/50"
            } rounded-2xl p-6 sm:p-8 space-y-4 animate-in fade-in duration-500`}
          >
            <div className="flex items-center justify-between">
              <h3 className="text-white text-xl font-semibold">Result</h3>
              <span
                className={`px-4 py-1 rounded-full text-sm font-medium ${
                  result.whitelisted ? "bg-green-500/20 text-green-400" : "bg-red-500/20 text-red-400"
                }`}
              >
                {result.whitelisted ? "Whitelisted" : "Not Whitelisted"}
              </span>
            </div>
            <div className="space-y-2">
              <p className="text-gray-400 text-sm">Address</p>
              <p className="text-white font-mono text-sm break-all">{result.address}</p>
            </div>
            {result.whitelisted ? (
              <div className="space-y-2">
                <p className="text-green-400 text-sm">This wallet address is whitelisted and eligible for access.</p>
                {result.addedAt && (
                  <p className="text-gray-400 text-xs">
                    Added on:{" "}
                    {new Date(result.addedAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                )}
              </div>
            ) : (
              <p className="text-red-400 text-sm">This wallet address is not currently whitelisted.</p>
            )}
          </div>
        )}

        {/* Info Section */}
        {/* <div className="bg-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-6 space-y-3">
          <h4 className="text-white font-semibold">About Whitelist</h4>
          <p className="text-gray-400 text-sm leading-relaxed">
            The whitelist verification system checks if your wallet address is registered in our database. Whitelisted
            addresses have access to exclusive features and benefits within the Monadscore ecosystem.
          </p>
        </div> */}
      </div>
    </div>
  )
}

export default CheckWhitelist
